// extracted by mini-css-extract-plugin
export default {"pageHeading":"DetailPageHeading_pageHeading__b0sUp"};